import type { Role } from '@takeshape/schema';
import { createReducer } from 'typesafe-actions';
import { createRoutineReducers, getInitialState } from '../common/utils/routine-reducer.js';
import { getRoleListRoutine } from './actions.js';

export type UserRoleListState = {
  loading: boolean;
  loaded: boolean;
  saving: boolean;
  error: string;
  data: Role[];
};

export const initialState = getInitialState([], 'loading', 'loaded');

export default createReducer<UserRoleListState>(initialState, {
  ...createRoutineReducers(getRoleListRoutine)
});
